(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('mainMenuV2', ["path", "routeHelper", "modulesManager", "feature", "troubleshooting", "sideMenuManager", "$timeout", "$cookies", "autologinHelper", "licensesManager", "policyDao", function (path, routeHelper, modulesManager, feature, troubleshooting, sideMenuManager, $timeout, $cookies, autologinHelper, licensesManager, policyDao) {
        return {
            restrict: 'A',
            replace: true,
            templateUrl: path('gui-v2').directive('main-menu-v2').template(),
            scope: { minimized: '=' },
            link: function ($scope, element, attrs) {
                $scope.openMenu = null;
                $scope.guiV2 = feature.guiV2;
                $scope.feature = feature;
                $scope.subMenuOnTheRight = sideMenuManager.subMenuOnTheRight();
                $scope.autologinCP = autologinHelper.enabled() || $cookies.get('autologinCP');
                function genConfigurationSubMenu() {
                    var configurationSubMenu = [
                        {
                            title: 'SaaS Apps',
                            icon: 'fa-laptop',
                            name: ['cloud-apps'],
                            features: [
                                'cloudAppsTab',
                                'avananTheme'
                            ],
                            allowedRoles: [
                                'admin',
                                'user'
                            ]
                        },
                        {
                            title: 'Cloud App Store',
                            icon: 'fa-laptop',
                            name: ['cloud-apps'],
                            feature: 'cloudAppsTab',
                            noFeature: 'avananTheme',
                            allowedRoles: [
                                'admin',
                                'user'
                            ]
                        },
                        {
                            title: 'Security Engines',
                            name: [
                                'app-store',
                                'app-store-filter'
                            ],
                            features: [
                                'appStoreTab',
                                'avananTheme'
                            ],
                            allowedRoles: [
                                'admin',
                                'user'
                            ]
                        },
                        {
                            title: 'Security App Store',
                            name: [
                                'app-store',
                                'app-store-filter'
                            ],
                            feature: 'appStoreTab',
                            noFeatures: [
                                'avananTheme',
                                'checkpointTheme'
                            ],
                            allowedRoles: [
                                'admin',
                                'user'
                            ]
                        },
                        {
                            title: 'Blades',
                            name: [
                                'app-store',
                                'app-store-filter'
                            ],
                            feature: 'checkpointTheme',
                            debugOnly: true,
                            allowedRoles: [
                                'admin',
                                'user'
                            ]
                        },
                        {
                            title: 'User Management',
                            icon: 'fa-tag',
                            name: [
                                'user-management',
                                'wizard-user-management'
                            ],
                            feature: 'userManagementTab'
                        },
                        {
                            title: 'Anomaly Exceptions',
                            icon: 'fa-lock',
                            name: 'anomaly-exceptions',
                            feature: 'showAnomalyExceptions'
                        },
                        {
                            title: 'Anti-Phishing Allow-List',
                            icon: 'fa-lock',
                            name: 'ap-avanan-exceptions',
                            activeSecApps: ['ap_avanan']
                        },
                        {
                            title: 'Anti-Phishing Block-List',
                            icon: 'fa-lock',
                            name: 'ap-avanan-blacklist',
                            activeSecApps: ['ap_avanan']
                        },
                        {
                            title: 'ClickTime Protection Exceptions',
                            icon: 'fa-lock',
                            name: 'clicktime-protection-list-management',
                            activeSecApps: ['clicktime_protection']
                        },
                        {
                            title: 'Security Exceptions',
                            icon: 'fa-lock',
                            name: 'security-exceptions',
                            feature: 'showWhitelist'
                        },
                        {
                            title: 'Security Tool Exceptions',
                            icon: 'fa-lock',
                            name: ['sec-tool-exceptions']
                        },
                        {
                            title: 'Settings',
                            icon: 'fa-cog',
                            name: ['settings']
                        },
                        {
                            title: 'Anti-Phishing Settings',
                            icon: 'fa-cog',
                            name: 'anti-phishing-settings',
                            feature: 'checkpointTheme'
                        },
                        {
                            title: 'Anomaly Detection Settings',
                            icon: 'fa-cog',
                            name: 'anomaly-detection-settings',
                            feature: 'checkpointTheme'
                        },
                        {
                            title: 'ClickTime Protection Settings',
                            icon: 'fa-cog',
                            name: 'clicktime-protection-settings',
                            features: [
                                'checkpointTheme',
                                'showClicktimeProtection'
                            ]
                        },
                        {
                            title: 'Licenses',
                            icon: 'fa-lock',
                            name: 'license-configuration',
                            noFeature: 'hideLicenseConfiguration'
                        }
                    ];
                    var availableSaases = [
                        'office365_emails',
                        'google_mail'
                    ];
                    $scope.licenseEnabledSaases = _(modulesManager.activeSaasApps()).filter(function (saas) {
                        return _(availableSaases).contains(saas.name);
                    }).map(function (saas) {
                        return saas;
                    });
                    return _(configurationSubMenu).reject(function (menu) {
                        if (menu.title === 'User Management') {
                            return !sideMenuManager.currentUser().admin || (feature.sonicwallTheme || feature.checkpointTheme && !feature.showUserManagmentCP) && !troubleshooting.entityDebugEnabled();
                        }
                        if (menu.title === 'Settings') {
                            // hide settings ('advanced') menu from checkpoint portal
                            if (feature.checkpointTheme) {
                                return true;
                            }
                            // hide settings if user is not an admin and he is from the sonicwallTheme portal
                            if (!sideMenuManager.currentUser().admin || feature.sonicwallTheme && autologinHelper.enabled()) {
                                return true;
                            }
                            // hide settings if user is a sonicwall customer and not hidden
                            if (!sideMenuManager.currentUser().hidden && feature.sonicwallTheme) {
                                return true;
                            }
                        }
                        if (menu.title === 'Licenses') {
                            // ui should always show the licenses screen for CP.
                            // display licenses screen in case licenses is available for avanan customers.
                            // Show license screen only if and licenses are not limited.
                            if (!licensesManager.licenseAvailability()) {
                                return true;
                            }
                            if (!$scope.licenseEnabledSaases.length) {
                                return true;
                            }
                            if (troubleshooting.entityDebugEnabled()) {
                                delete menu.noFeature;
                            }
                        }
                        if (menu.allowedRoles) {
                            return _(menu.allowedRoles).findIndex(function (role) {
                                return role === sideMenuManager.currentUser().role;
                            }) === -1;
                        }
                        return false;
                    });
                }
                var quarantineSubMenu = [
                    {
                        title: 'Quarantine items',
                        name: 'quarantine'
                    },
                    {
                        title: 'Restore requests',
                        name: 'restore-requests',
                        activeSaases: [
                            'office365_emails',
                            'google_mail'
                        ]
                    },
                    {
                        title: 'User reported phishing',
                        name: 'report-phishing',
                        activeSaases: ['office365_emails'],
                        feature: 'enableUserReportedPhishing'
                    },
                    {
                        title: 'Threat extracted emails',
                        name: 'threat-extracted-emails',
                        activeSecApps: ['cp_threat_extraction']
                    },
                    {
                        title: 'Extracted restore requests',
                        name: 'extracted-restore-requests',
                        activeSecApps: ['cp_threat_extraction']
                    }
                ];
                function genMainMenus(configSubMenu) {
                    var menus = [
                        {
                            title: 'Dashboard',
                            name: 'dashboard',
                            icon: 'icomoon-dashboard',
                            noFeature: 'checkpointTheme'
                        },
                        {
                            title: 'Overview',
                            name: 'dashboard',
                            bigIcon: 'icomoon-cp-dashboard',
                            icon: 'icomoon-dashboard',
                            feature: 'checkpointTheme'
                        },
                        {
                            title: 'Events',
                            name: 'security-events',
                            bigIcon: 'icomoon-events',
                            icon: 'icomoon-calendar'
                        },
                        {
                            title: 'Policy',
                            name: 'policy-rules',
                            bigIcon: 'icomoon-policy',
                            icon: 'icomoon-list'
                        },
                        {
                            title: 'Drive Explorer',
                            bigIcon: 'icomoon-search',
                            icon: 'icomoon-search',
                            name: 'drive-explorer',
                            saas: [
                                'google_drive',
                                'box'
                            ],
                            feature: 'driveAnaliticsTab',
                            submenus: [
                                {
                                    title: 'Google Drive',
                                    name: 'drive-explorer',
                                    params: { module: 'google_drive' },
                                    saas: ['google_drive'],
                                    activeMatchParams: true
                                },
                                {
                                    title: 'Box',
                                    name: 'drive-explorer',
                                    params: { module: 'box' },
                                    saas: ['box'],
                                    activeMatchParams: true
                                }
                            ]
                        },
                        feature.mailExplorer2 ? {
                            title: 'Mail Explorer',
                            bigIcon: 'icomoon-search',
                            icon: 'icomoon-search',
                            name: 'mail-explorer-new',
                            saas: [
                                'google_mail',
                                'office365_emails'
                            ]
                        } : {
                            title: 'Mail Explorer',
                            bigIcon: 'icomoon-search',
                            icon: 'icomoon-search',
                            name: 'mail-explorer',
                            saas: [// 'google_mail',
                                'office365_emails'],
                            submenus: [// {
                                //     title: 'Google Mail',
                                //     name: 'mail-explorer',
                                //     params: {
                                //         module: 'google_mail'
                                //     },
                                //     saas: ['google_mail'],
                                //     activeMatchParams: true
                                // },
                                {
                                    title: 'Office 365 Mail',
                                    name: 'mail-explorer',
                                    params: { module: 'office365_emails' },
                                    saas: ['office365_emails'],
                                    activeMatchParams: true
                                }]
                        },
                        {
                            title: 'Analytics',
                            noFeature: 'checkpointTheme',
                            name: [
                                'policy-list',
                                'analytics'
                            ],
                            icon: 'icomoon-dashboard',
                            submenus: []
                        },
                        {
                            title: 'Analytics',
                            name: [
                                'summary-report',
                                'analytics'
                            ],
                            feature: 'checkpointTheme',
                            bigIcon: 'icomoon-analytics',
                            submenus: []
                        },
                        // {
                        //     title: 'Security Stack',
                        //     name: 'security-stack',
                        //     icon: 'icomoon-shield',
                        //     noFeatures: ['checkpointTheme', 'lastlineTheme', 'sonicwallTheme']
                        // },
                        {
                            title: 'Quarantine',
                            name: 'quarantine',
                            bigIcon: 'icomoon-quarantine',
                            icon: 'icomoon-close-circle',
                            submenus: quarantineSubMenu
                        },
                        {
                            title: 'Audit',
                            name: [
                                'system-tasks',
                                'system-log'
                            ],
                            bigIcon: 'icomoon-settings',
                            icon: 'icomoon-settings',
                            submenus: [
                                {
                                    title: 'System Tasks',
                                    name: 'system-tasks',
                                    feature: 'enableSystemTask'
                                },
                                {
                                    title: 'System Logs',
                                    name: 'system-log'
                                }
                            ],
                            noFeature: 'checkpointTheme'
                        },
                        {
                            title: 'Config',
                            name: ['cloud-apps'],
                            bigIcon: 'icomoon-configuration',
                            icon: 'icomoon-close-circle',
                            feature: 'checkpointTheme',
                            submenus: configSubMenu
                        },
                        {
                            title: 'Configuration',
                            name: [
                                'cloud-apps',
                                'app-store'
                            ],
                            icon: 'icomoon-settings',
                            noFeature: 'checkpointTheme',
                            // nolink: true,
                            submenus: configSubMenu
                        }
                    ];
                    // removes undefined parts
                    for (var i = 0; i < menus.length; i++) {
                        var menu = menus[i];
                        if (menu === undefined) {
                            menus.splice(i, 1);
                        }
                    }
                    return menus;
                }
                var menuItem;
                var menuWidth;
                var menuTop;
                var submenu;
                var submenuHeight;
                var baseHeight;
                function updateSubmenuPosition(e) {
                    if ($scope.minimized) {
                        if (!$.contains(element[0], $(e.target)[0]) && $(e.target).closest('.openable').length <= 0) {
                            $timeout(function () {
                                $scope.openMenu = null;
                            }, 0);
                        }
                    }
                }
                function onWindowResize() {
                    if (menuItem) {
                        menuTop = menuItem[0].getBoundingClientRect().top;
                        if (submenu && submenu[0] && window.innerHeight > submenuHeight && window.innerHeight > menuTop + submenuHeight) {
                            submenu.css({
                                'top': menuTop + 'px',
                                'bottom': 'auto'
                            });
                        } else if (submenu && submenu[0] && window.innerHeight < submenuHeight || window.innerHeight < menuTop + submenuHeight) {
                            submenu.css({
                                'top': 'auto',
                                'bottom': '0px'
                            });
                        }
                    }
                }
                $scope.menuItemClicked = function (e, menu) {
                    menuItem = $(e.currentTarget);
                    if (menu.submenus) {
                        if ($scope.openMenu == menu && e.isDefaultPrevented()) {
                            $scope.openMenu = null;
                        } else if ($scope.openMenu != menu && e.isDefaultPrevented()) {
                            $timeout(function () {
                                $scope.openMenu = menu;
                                menuWidth = menuItem[0].getBoundingClientRect().width + 1;
                                menuTop = menuItem[0].getBoundingClientRect().top;
                                submenu = menuItem.find('.submenu');
                                if (submenu.length > 0) {
                                    submenu[0].scrollIntoView();
                                    submenu.css({
                                        'top': menuTop + 'px',
                                        'left': menuWidth + 'px'
                                    });
                                    baseHeight = $(e.currentTarget).outerHeight();
                                    var subItems = submenu.find('li');
                                    submenuHeight = baseHeight * subItems.length;
                                    if (menuTop + submenuHeight > window.innerHeight && submenuHeight < window.innerHeight) {
                                        submenu.css({
                                            'top': 'auto',
                                            'bottom': '0px'
                                        });
                                    } else if (submenuHeight >= window.innerHeight) {
                                        submenu.css({
                                            'top': 'auto',
                                            'bottom': '0px'
                                        });
                                    }
                                }
                            }, 0);
                        } else {
                            if ($scope.openMenu) {
                                $scope.openMenu = null;
                            } else {
                                $scope.openMenu = menu;
                            }
                        }
                    } else {
                        $scope.openMenu = null;
                    }
                };
                function setMenuHref(menu, activeModules) {
                    if (!menu.name || menu.nolink) {
                        return;
                    }
                    if (_(menu.saas).isUndefined()) {
                        menu.href = routeHelper.getHref(menu.name, menu.params);
                    } else {
                        menu.href = routeHelper.getHref(menu.name, $.extend({ module: _(menu.saas).intersection(activeModules)[0] }, menu.params));
                    }
                }
                function filterMenuItems(menus, activeModules, activeSecApps, activeSaasApps) {
                    return _(menus).chain().filter(function (menu) {
                        return !menu.debugOnly || troubleshooting.entityDebugEnabled();
                    }).filter(function (menu) {
                        return _(menu.feature).isUndefined() || feature[menu.feature];
                    }).filter(function (menu) {
                        var isTrue = true;
                        if (menu.features) {
                            isTrue = _(menu.features).findIndex(function (feat) {
                                return feature[feat] !== true;
                            }) === -1;
                        }
                        return isTrue;
                    }).filter(function (menu) {
                        return _(menu.noFeature).isUndefined() || !feature[menu.noFeature];
                    }).filter(function (menu) {
                        var isTrue = true;
                        if (menu.noFeatures) {
                            isTrue = _(menu.noFeatures).findIndex(function (noFeature) {
                                return feature[noFeature] === true;
                            }) === -1;
                        }
                        return isTrue;
                    }).filter(function (menu) {
                        return _(menu.saas).isUndefined() || _(menu.saas).intersection(activeModules).length > 0;
                    }).filter(function (menu) {
                        return !menu.activeSecApps || !!_(menu.activeSecApps).find(function (app) {
                            return _(activeSecApps).find(function (secApp) {
                                return secApp.name === app && (!secApp.gui_hidden || troubleshooting.entityDebugEnabled());
                            });
                        });
                    }).filter(function (menu) {
                        return !menu.activeSaases || !!_(menu.activeSaases).find(function (saas) {
                            return _(activeSaasApps).find(function (activeSaas) {
                                return activeSaas.name === saas;
                            });
                        });
                    }).filter(function (menu) {
                        return !menu.admin || sideMenuManager.currentUser().admin;
                    }).map(function (menu) {
                        if (menu.submenus) {
                            menu.submenus = filterMenuItems(menu.submenus, activeModules, activeSecApps, activeSaasApps);
                        }
                        return menu;
                    }).value();
                }
                function addAnalyticsMenu(menus) {
                    var specialPages = {
                        'ms_azure': 'azure-dashboard',
                        'summary-report': 'summary-report',
                        'shadow-it': 'shadow-it'
                    };
                    if (feature.showOldShadowIt) {
                        delete specialPages['shadow-it'];
                    }
                    var analyticsMenus = [];
                    var summaryReport = {};
                    _.each(menus, function (menu) {
                        var checkName = _.indexOf(menu.name, 'analytics');
                        if (checkName > -1 && menu.submenus)
                            analyticsMenus.push(menu);
                    });
                    if (analyticsMenus == []) {
                        return menus;
                    }
                    _(modulesManager.cloudApps()).each(function (app) {
                        if (app.name === 'super-dashboard') {
                            return;
                        }
                        if (app.name === 'summary-report') {
                            summaryReport = {
                                title: app.title,
                                name: specialPages[app.name]
                            };
                            return;
                        }
                        _.each(analyticsMenus, function (menu) {
                            if (specialPages[app.name]) {
                                menu.submenus.push({
                                    title: app.title,
                                    name: specialPages[app.name]
                                });
                            } else {
                                menu.submenus.push({
                                    title: app.title,
                                    name: 'analytics',
                                    params: { page: app.name },
                                    activeMatchParams: true
                                });
                            }
                        });
                    });
                    _(analyticsMenus).each(function (menu) {
                        if (_(menu.submenus).findIndex(function (submenu) {
                                return submenu.name === 'shadow-it';
                            }) === -1) {
                            var shadowItMenu = {
                                title: 'Shadow IT',
                                name: 'shadow-it'
                            };
                            if (feature.sonicwallTheme) {
                                shadowItMenu.title = 'Shadow SaaS';
                            }
                            menu.submenus.push(shadowItMenu);
                        }
                        if (menu.noFeature === 'checkpointTheme') {
                            menu.submenus.unshift({
                                title: 'Custom queries',
                                name: 'policy-list'
                            });
                            menu.submenus.push(summaryReport);
                        } else if (menu.feature === 'checkpointTheme') {
                            menu.submenus.unshift({
                                title: 'Custom queries',
                                name: [
                                    'policy-list',
                                    'policy-edit',
                                    'policy-create'
                                ]
                            });
                            menu.submenus.push(summaryReport);
                        }
                        if (feature.showPhishingDashboard || troubleshooting.entityDebugEnabled()) {
                            menu.submenus.push({
                                title: 'Phishing Dashboard',
                                name: 'phishing-dashboard'
                            });
                        }
                        var enableWeeklyReports = feature.avananTheme || feature.checkpointTheme;
                        if (feature.sonicwallTheme) {
                            enableWeeklyReports = !!sideMenuManager.currentUser().admin;
                        }
                        if (enableWeeklyReports) {
                            menu.submenus.push({
                                title: 'Periodic Reports',
                                name: 'weekly-reports'
                            });
                        }
                    });
                    return menus;
                }
                function setMenus(menus) {
                    var activeModules = _(modulesManager.cloudApps()).pluck('name');
                    var activeSecApps = modulesManager.activeSecAppsFull();
                    var activeSaasApps = modulesManager.activeSaasApps();
                    $scope.menus = filterMenuItems(addAnalyticsMenu(angular.copy(menus)), activeModules, activeSecApps, activeSaasApps);
                    _($scope.menus).each(function (menu) {
                        // check right link when clicking expandable menu
                        if (menu.submenus && menu.submenus.length) {
                            var menuName = '';
                            if (_(menu.name).isArray() && menu.name.length) {
                                menuName = menu.name[0];
                            } else if (!_(menu.name).isArray()) {
                                menuName = menu.name;
                            } else {
                                return;
                            }
                            if (_(menu.submenus).findIndex(function (submenu) {
                                    if (_(submenu.name).isArray() && submenu.name.length) {
                                        return menuName === submenu.name[0];
                                    }
                                    if (!_(submenu.name).isArray()) {
                                        return menuName === submenu.name;
                                    }
                                    return false;
                                }) === -1) {
                                menu.name = menu.submenus[0].name;
                            }
                        }
                        menu.isActive = function () {
                            return routeHelper.isActive(menu.name);
                        };
                        setMenuHref(menu, activeModules);
                        _(menu.submenus).each(function (item) {
                            setMenuHref(item, activeModules);
                            item.isActive = function () {
                                return routeHelper.isActiveMenu(item);
                            };
                        });
                    });
                }
                $scope.$watch('minimized', function (newValue, oldValue) {
                    if (oldValue && !newValue) {
                        $scope.openMenu = _.findWhere($scope.menus, { active: true });
                    } else {
                        $scope.openMenu = null;
                    }
                });
                function recheckMenus() {
                    sideMenuManager.activeMenu(null);
                    _($scope.menus).each(function (menu) {
                        menu.active = routeHelper.isActive(menu.name) || !!_(menu.submenus).find(function (item) {
                            return routeHelper.isActiveMenu(item);
                        });
                        if ($scope.minimized) {
                            $scope.openMenu = null;
                        } else if (menu.active && !$scope.minimized) {
                            $scope.openMenu = menu;
                        }
                        if (menu.active) {
                            sideMenuManager.activeMenu(menu);
                        }
                    });
                }
                $scope.$on('$locationChangeSuccess', recheckMenus);
                $scope.$watch('menus', recheckMenus);
                function init() {
                    modulesManager.init().then(function () {
                        licensesManager.init().then(function () {
                            var configSubMenu = genConfigurationSubMenu();
                            var mainMenu = genMainMenus(configSubMenu);
                            setMenus(mainMenu);
                        }, function () {
                            var configSubMenu = genConfigurationSubMenu();
                            var mainMenu = genMainMenus(configSubMenu);
                            setMenus(mainMenu);
                        });
                    });
                }
                $scope.$watch(function () {
                    return sideMenuManager.menuStateCounter();
                }, function () {
                    init();
                });
                $scope.$watch(function () {
                    return modulesManager.stateCounter();
                }, function () {
                    init();
                });
                $(window).on('resize', onWindowResize);
                $(window).on('click', updateSubmenuPosition);
                element.on('$destroy', function () {
                    $(window).off('resize', onWindowResize);
                    $(window).off('click', updateSubmenuPosition);
                });
            }
        };
    }]);
}());